import { request } from '../request';

export type SingleShiftTemplateCreateData = {
  name: string;
  shiftTimePresetTemplateId: string; // 'shifttimepresettemplate-00000000000000000000000000';
  recurrenceType: 'single' | 'series' | 'rotation';
  startTime: string; // '00:00:00';
  durationInSeconds: number;
  durationInDays: number;
  seriesRecurrence: string;
  rotationRecurrence: string;
  departmentNodeId: string; // 'departmentnode-00000000000000000000000000';
  subDepartmentNodeId: string; // 'departmentnode-00000000000000000000000000';
  specialtyId: string; // 'speciality-00000000000000000000000000';
  qualificationIds: string[]; // ['nursequalification-00000000000000000000000000'];
  tags: string[];
  locationId: string;
};
export function createSingleShiftTemplate(data: SingleShiftTemplateCreateData) {
  return request.post<void>('/v2/templates/shifts', {
    ...data,
    recurrenceType:
      data.recurrenceType === 'single' ? 'Single' : data.recurrenceType === 'series' ? 'Series' : 'Rotation',
    shiftTimePresetTemplateId: data.shiftTimePresetTemplateId || null,
    subDepartmentNodeId: data.subDepartmentNodeId || null,
    departmentNodeId: data.departmentNodeId || null,
    specialityId: data.specialtyId || null,
  });
}
